// cleanup_convert_to_typescript_file_LOGIN_WORKFLOW

import React from 'react';
import Login from './Login';

export default function LoginWrapper() {
  return (
    <div className="login-screen" data-qa="login-screen">
      <div className="glu">
        <div className="glu-content">
          <div>
            <Login />
          </div>
        </div>
      </div>
    </div>
  );
}
